/* eslint-disable prettier */
/**
 * PT BR Resource file
 */

import {
	roles,
	daySelection,
	GARoleTypeId,
	toggleCCPEntityDetail,
	readinessReportCategories,
	archiveReportQualifiedTypeId,
	natureOfEngagements,
	dashboardTabId,
	dashboardViews as dashboardViewsConstants,
	accountDesignations,
	groupRiskStatus,
	riskTypeIds
} from '../util/uiconstants';

export const labels = {
	clearFilter: 'Clear all',
	canvasOversight: 'Canvas Oversight',
	oversight: 'Oversight',
	canvasLabel: 'Canvas',
	myProjects: 'My Projects',
	otherProjects: 'Other Projects',
	priorProjects: 'Prior projects',
	completedProjects: 'Completed projects',
	completedLabel: 'Completed',
	createProject: 'Create project',
	rollForward: 'Roll forward',
	rollForwardLabel: 'Roll Forward',
	rollForwardTitle: 'Roll forward your project',
	project: 'Project',
	openProject: 'Open project',
	manageUsers: 'Manage users',
	rollForwardInstructionalText: 'Are you sure that you want to roll forward your project? <br> This will allow you to use your completed project as a template when creating a new project. The following information will be rolled forward: project name, organizational chart, groups and group administrators.',
	isClientUserError: 'You do not have any active projects. Speak with an EY team member to be invited to a project.',
	activeProjects: 'Active projects',
	myActiveProjects: 'My active projects',
	otherActiveProjects: 'Other active projects',
	myCompletedProjects: 'My completed projects',
	myActiveProjectsPlaceholder: 'You have access to the EY Canvas Oversight projects listed here. Select a project name to open it or click on a count to see details.',
	deleteProject: 'Delete project',
	deleteProjectModalText: 'Are you sure that you want to delete this project?<br>The project will be removed from your landing page and will no longer be accessible for any team members.',
	createButton: 'Create project',
	search: 'Search',
	searchEngagement: 'Search engagement',
	searchEngagements: 'Search engagements',
	searchEntitiesAndEngagements: 'Search entities and engagements',
	searchClientList: 'Search client name',
	noDataFound: 'There is no data to display.',
	expand: 'Expand',
	collapse: 'Collapse',
	more: 'More',
	options: 'Options',
	editProject: 'Edit project',
	manageTeam: 'Manage team',
	markAsCompleted: 'Mark as completed',
	connectedTo: 'Connected to',
	connectedClients: 'Connected clients',
	connectedToClients: (count) => `${count} ${count == 1 ? 'client' : 'clients'}`,
	connectedToEngagements: (count) => `Engagements: ${count == 0 ? 'None' : count}`,
	countEngagements: (count) => `${count} ${count === 1 ? 'engagement' : 'engagements'}`,
	connectToEngagements: (count) => `Connect ${count} ${count == 1 ? 'engagement' : 'engagements'}`,
	connectedToAccessGroups: (count) => `Connected to ${count} ${count == 1 ? 'group' : 'groups'}`,
	connectToAccessGroups: (count) => `Connect ${count} ${count == 1 ? 'group' : 'groups'}`,
	entitiesLabelForCount: (count) => `${count} ${count == 1 ? 'Entity' : 'Entities'}`,
	viewsLabelForCount: (count) => `${count} ${count == 1 ? 'View' : 'Views'}`,
	domainsLabelForCount: (count) => `${count} ${count == 1 ? 'Domain' : 'Domains'}`,
	viewsLabelWithoutCount: (count) => `${count == 1 ? 'View' : 'Views'}`,
	domainsLabelWithoutCount: (count) => `${count == 1 ? 'Domain' : 'Domains'}`,
	engagement: 'engagement',
	engagementNameLabel: 'Engagement Name',
	engagementPartnerLabel: 'Engagement Partner',
	partnerLabel: 'Partner',
	notInvited: 'Not invited',
	clientNameLabel: 'Client Name',
	client: 'Clients',
	codeLabel: 'Code',
	idLabel: 'ID',
	engagements: 'engagements',
	engagementsLabel: 'Engagements',
	noResultsFound: 'No results found.',
	submit: 'Submit',
	saveAndContinue: 'Save & Continue',
	savecontinue: 'Save & continue',
	saveDraft: 'Save as draft',
	closeLabel: 'Close',
	step1: 'Step 1',
	step2: 'Step 2',
	step3: 'Step 3',
	step4: 'Step 4',
	step5: 'Step 5',
	adminsNoneLabel: 'None',
	domainsAllLabel: 'All',
	adminsHeaderLabel: 'Admins: ',
	domainsHeaderLabel: 'Domains: ',
	moreCountLabel: '+ {0}',
	selectClient: 'Select a client',
	createOrgChart: 'Create org chart',
	connnectToCanvas: 'Connect to EY Canvas',
	viewSummary: 'View summary',
	viewLabel: 'View',
	cancelLabel: 'Cancel',
	required: 'Required',
	filter: 'filter',
	filtersWarningMessage: 'Filter limit exceeded. Only 25 filters can be applied at one time.',
	back: 'Back',
	save: 'Save',
	saveClose: 'Save & close',
	continue: 'Continue',
	finish: 'Finish',
	saveChanges: 'Save changes',
	projectName: 'Project name',
	projectOwners: 'Project owners',
	addAnotherProjectOwner: 'Add another project owner',
	duplicateOwnerAdded: 'Duplicate user',
	step1InstructionHeader: 'Enter a name for your project, add additional project owners, and select one or more clients from the list below to get started.',
	step1SubInstructionPart1: `You must have access to the client's GIS, GFIS, or Mercury codes or to an EY Canvas engagement to see the client's name below. The clients that you select on this step will determine which EY Canvas engagements are available to connect to your project. To learn more on how to use EY Canvas Oversight, check out our {link}`,
	step2InstructionHeader: 'Create an organizational chart for your project.',
	step2SubInstructionPart1: 'The organizational chart should mirror how your client manages their business. It will be used to summarize data for the EY Canvas engagements that you connect to your project and to manage access for internal and external team members.',
	here: 'here',
	zoomIn: 'Zoom in',
	zoomOut: 'Zoom out',
	expandAll: 'Expand all',
	collapseAll: 'Collapse all',
	addLabel: 'Add',
	editLabel: 'Edit',
	removeLabel: 'Remove',
	noRowsTemplateStringPart1: 'You do not have access to any clients. Click',
	noRowsTemplateStringPart2: 'to learn more about how to get access. ',
	noRowSelected: 'Select at least one client to continue.',
	firstName: 'First name',
	lastName: 'Last name',
	displayLanguage: 'Display language',
	numberFormat: 'Number format',
	dateFormat: 'Date format',
	timezone: 'Time zone',
	theme: 'Theme',
	chooseDisplayTheme: 'Choose your default display theme.',
	light: 'Light',
	dark: 'Dark',
	usersettings: 'User settings',
	userOptions: 'User options',
	clearHoverText: 'Clear',
	noFiltersAvailable: 'No filters available',
	dashboard: 'Dashboard',
	milestones: 'Milestones',
	activityFeed: 'Activity feed',
	keyEvents: 'Key events',
	keyEventCompletion: 'Key event completion',
	canvasClientPortal: 'Canvas Client Portal',
	canvasClientPortalEy: 'EY Canvas Client Portal',
	groupAudit: 'Group audit',
	projectManagement: 'Project management',
	reporting: 'Reporting',
	insights: 'Insights',
	groupRiskAssessment: 'Group risk assessment',
	internal: 'Internal',
	external: 'External',
	members: 'members',
	show: 'Show',
	showDetails: 'Show details',
	showMore: 'Show more',
	showLess: 'Show less',
	clientName: 'Client name',
	clientsLabel: 'Clients',
	clientLabel: 'Client',
	source: 'Source',
	code: 'Code',
	accessDelegatedBy: 'Access delegated by ',
	returnToPreviousStep: 'Return to a previous step',
	backButtonWarning: 'If you return to a previous step and make changes, your progress on this step may be impacted.<br> Select <b>Continue</b> to return to a previous step or <b>Cancel</b> to remain on this step.',
	step1SubInstructionPart3: 'The clients that you select on this step will determine which EY Canvas engagements are available to connect your project to.',
	step3InstructionHeader: 'Select one or more EY Canvas engagements, then drag and drop them onto your organizational chart.',
	step3InstructionPara: 'The connection between EY Canvas engagements and entities on your organizational chart determines how EY Canvas data is summarized on the dashboard for your project.',
	availableLabel: 'Available',
	connectedLabel: 'Connected',
	milestoneSummaryView: 'Milestone - summary view',
	taskCompletionByMilestone: 'Task completion by milestone',
	basedOnTaskCompletition: 'Based on task completion',
	scopeAndStrategy: 'Scope & Strategy',
	execution: 'Execution',
	conclusion: 'Conclusion',
	step3ListDefaultMessage: 'There are no engagements available for the client(s) that you selected on Step 1. Return to Step 1 and select a different client to continue.',
	addNewEngagementLabel: 'Add new engagement',
	selectedLabel: 'selected',
	moreText: 'more',
	connectLabel: 'Connect',
	connectEngagements: 'Connected engagements',
	connectToAnEngagement: 'Connect an engagement to get started.',
	connectToAnAccessGroup: 'No groups have been connected.',
	tasks: 'Tasks',
	organizationalChartHeading: 'Entities',
	groupAdministratorsLabel: 'Group administrators',
	step4InstructionHeader: 'Create groups for your project and connect them to one or more entities in your organizational chart.',
	step4ImportantNote: 'Important note: Members of a group can view EY Canvas engagement data for the organizational chart entities that you connect the group to and any children of those entities. If you connect a group to a parent entity on your organizational chart, the group will be able to view EY Canvas engagement data for the parent entity and all of its children.',
	addAGroup: 'Add a group',
	addGroup: 'Add group',
	searchGroup: 'Search groups',
	addNewGroupHeader: 'Create a new group here.',
	editNewGroupHeader: 'Edit an existing group here.',
	addNewGroupInstruction: 'After your project is created, you can invite internal and external team members to this group. You have the option to add a group administrator who can also invite members to this group.',
	groupName: 'Group name',
	groupAdministrators: 'Group administrators (optional)',
	groupAdministratorsSubHeading: 'Add a group administrator. Group administrators can invite members to your project after it is created. They cannot edit the views and domains for this group.',
	clearAllValues: 'Clear',
	createGroupDashboardViews: 'Dashboard views',
	dashboardViewsSubHeading: 'Select at least one view. This determines the data that members can see when they view the dashboard for your project.',
	duplicateDomain: 'Duplicate domain',
	allMilestones: 'All Milestones',
	someMilestonesSelected: '{0} milestones selected',
	noGroupsAdded: 'No domains have been added for this project.',
	step5InstructionHeader: 'Review your EY Canvas Oversight project.',
	step5SubInstruction: 'If you need to make changes, select the Edit pencil to return to an earlier step. <b>Making changes to an earlier step may impact progress on later steps.</b>',
	associationNotRequired: 'Association not required',
	accessGroupAlreadyAddedToParent: 'You already associated one or more of the selected groups to a parent entity. If an access group is connected to a parent entity, then its members can view EY Canvas engagement data for the parent entity and all of its children. Therefore, association is not required.',
	deleteGroupInstructionalText: 'Are you sure that you want to delete this group? <br> Once deleted, the operation cannot be undone. Members of the group will no longer be able to access your project.',
	deleteGroup: 'Delete group',
	removeMember: 'Remove a member',
	removeMemberTitle: 'Are you sure that you want to remove this team member? If the member belongs to multiple groups, then they will be removed from all of the groups listed here and may no longer be able to access this project. If you only want to remove the member from a single group, then select the <b>Edit</b> option instead.',
	teamMember: 'Team member',
	clientNameLbl: 'Clients',
	help: 'Help',

	//Org char left rail
	filters: 'Filters',
	countEngagementSelected: '{0} of {1} engagements selected',
	of: '{num} of',
	entityName: 'Entity name',
	enterEntityName: 'Enter name here',
	projectOwner: 'Project owner',
	role: 'Role',
	domains: 'Domains (optional)',
	domainSubHeading: 'Add at least one domain if external team members will be invited to this group. Domain refers to the characters after the @ symbol in an email address. To add an external team member, they must have a valid domain for this group.',
	addAdministrator: 'Add a group administrator',
	addNewDomain: 'Add a new domain',
	addExistingDomain: 'Add an existing domain',
	placeholderStep3NoEngagementMessage: 'There are no engagements available for the client(s) that you selected on Step 1. Return to Step 1 and select a different client to continue.',
	placeholderStep3NoConnectedEngagementMessage: 'There are no connected engagements yet.',
	placeholderStep3AllEngagementsConnected: 'All available engagements are connected to your project.',
	placeholderStep4NoConnectedGroupMessage: 'There are no connected groups yet.',
	domainName: 'Domain name',
	engagementLabel: 'Engagement',
	start: 'Start',
	end: 'End',
	suggestedEnd: 'Suggested end',
	status: 'Status',
	thereIsNoDataToDisplay: 'There is no data to display.',
	selectadditionalEntitiesToContinue: 'Select additional entities to continue.',
	comingSoonToDisplay: 'Component status will be available soon.',
	checkForUpdatesToDisplay: 'Check back in the coming weeks for updates.',
	userSearchPlaceholder: 'Enter name or email and press Enter to see results.',
	userSearchPlaceholderForExternal: 'Enter email and press enter to see results.',
	partnerInChargeInvitedToTheEngagement: 'Partner in charge invited to the engagement',
	partnerInChargeSignedOffOnCraSummary: 'Partner in charge signed off on CRA summary',
	eqrSignedOffOnCraSummary: 'EQR signed off on CRA summary',
	partnerInChargeSignedOffOnAuditPlan: 'Partner in charge signed off on Audit plan',
	picInvited: 'PIC invited',
	picSignOffCRA: 'PIC sign off on CRA',
	picSignOffAuditPlan: 'PIC sign off on Audit plan',
	eqrSingOffCRA: 'EQR sign off on CRA',
	overdue: 'overdue',
	outOf: 'out of',
	edit: 'Edit',
	remove: 'Remove',
	add: 'Add',
	admin: 'Admins',
	views: 'Views',
	domainLabel: 'domain',
	domainslabel: 'Domains',
	viewLabelText: 'view',
	viewsLabelText: 'views',
	administrators: 'Administrators',
	none: 'None',
	organizationChart: 'Organizational Chart',
	invalidDomainName: 'Invalid domain name',
	lastRefreshed: 'Last refreshed',
	lastRefreshedActivityFeed: 'Activity feed data last refreshed',
	lastRefreshedReconciliation: 'Reconciliation data last refreshed',
	quickFilter: 'Quick filter',
	notApplied: 'Not applied',
	quickFilterInput: 'Quick filter name',
	quickFilterSubHeaderText: 'When you are done, you can apply the quick filter to refine the entities that you would like to view data for without having to individually select each one.',
	createFilterTrigger: 'Create new filter',
	createFilterTitle: 'Create new quick filter',
	createFilterButton: 'Create quick filter',
	createFilterHeaderText: 'Select one or more organizational chart entities to create a quick filter.',
	createFilterSubHeaderText: 'When you are done, you can apply the quick filter to refine the entities that you would like to view data for without having to individually select each one.',
	editFilterTitle: 'Edit quick filter',
	editFilterHeaderText: 'Edit or delete a quick filter.',
	editFilterIconTitleTip: 'Edit',
	oneRequired: 'At least one selection is required.',
	noFiltersCreatedTitle: 'No quick filters created yet.',
	noFiltersCreatedSubTitle: 'Create a quick filter to get started.',
	clear: 'Clear',
	completionRange: 'Completion range',
	engagementCount: 'Engagement count',
	clickOnAVisualBelowToFilterTheEngagementList: 'Click on a visual below to filter the engagement list.',
	organizationalChartTooltip: 'Select Organizational chart to edit or remove entities from your Oversight Project.',
	organizationalChart: 'Organizational chart',

	//Task status chart labels
	open: 'Open',
	inProgress: 'In progress',
	inReview: 'In review',
	completeUpperCase: 'Complete',
	taskStatusOverdue: 'Overdue',
	noDataForSelections: 'There is no data available for your selections.',
	selectOneOrMoreMilestones: 'Select one or more different milestones to continue.',
	milestoneDetailTitle: 'Milestones - detail',
	taskStatusByMilestone: 'Task status by milestone',
	milestoneDetailSubtitle: 'Based on task status',
	basedOnAllTasksForTheSelectedMilestone: 'Based on all tasks for the selected milestone(s)',
	totalTasks: 'total tasks',
	noneSelected: 'None selected',
	nameOrEmail: 'Name or email',
	remove: 'Remove',
	milestonesTooltipText: 'Audit progress by milestone',
	canvasClientPortalTooltipText: 'Request status, including coming due, overdue and returned items',
	groudAuditTooltipText: 'Primary and component team status, including returned and overdue items',
	projectManagementTooltipText: 'Status of review notes and assignments, including overdue items. This view will not be visible to clients.',
	insightsTootipText: 'Comparison of risks, substantive procedures, control strategy and findings between primary and component teams. This view will not be visible to clients.',
	reportTootipText: 'Report readiness, modification and task completion status by country',
	taskStatusComplete: 'Task status - Complete',
	taskStatusInreview: 'Task status - In review',
	taskStatusInprogress: 'Task status - In progress',
	taskStatusOpen: 'Task status - Open',

	//Review Notes chart labels
	reviewNotesByStatusTitle: 'All review notes',
	byStatus: 'By status',
	totalNotes: 'total notes',
	totalNotesLabel: 'Total notes',
	openNotes: 'Open notes',
	byPriority: 'By priority',
	cleared: 'Cleared',
	closed: 'Closed',
	low: 'Low',
	medium: 'Medium',
	high: 'High',
	critical: 'Critical',
	notesTableTooltipContent: 'Based on notes with Open status',

	// Group audit
	groupAuditTotalForms: 'Total forms',
	groupAuditNotSent: 'Not sent',
	groupAuditUnlinked: 'Unlinked',
	totalTasksCapitalized: 'Total tasks',
	primary: 'Primary',
	component: 'Component',

	//Bar chart
	are: 'are',
	complete: 'complete',
	noMilestoneDataForSelection: 'There is no milestone data to display for this audit phase.',
	selectDifferentAuditPhase: 'Select a different audit phase or select additional entities to continue.',

	//Delegate
	delegateInstruction: "Delegate access to your other team member so they can create projects on your behalf. Enter a team member's name or email address to get started. Your delegates will have access to all of your clients.",

	delegateAccess: 'Manage delegates',
	addAnother: 'Add delegates',
	hideMyDelegate: 'Hide my delegates',
	showMyDelegate: 'Show my delegates',
	noRecord: 'No results found',
	duplicateUser: 'Delegate already added',
	duplicateUserMessage: 'User already added',
	addDelegates: 'Add delegates',
	delegateTo: 'Delegated to',
	delegateFrom: 'Delegated from',
	delegateToMsg: 'You have not delegated your access to any team members.',
	delegateFromMsg: 'No team members have delegated their access to you.',

	// Project dashboard left rail
	searchFilterPlaceholder: 'Search filters',
	searchEntitiesPlaceholder: 'Search entities',
	outOfEngagements: '<b>{0}</b> out of <b>{1}</b> engagements',
	engagementCompletedBasedOnTaskCompletion: '<b>{0}</b> engagement is <b>{1}</b> complete based on task completion',
	engagementsCompletedBasedOnTaskCompletion: '<b>{0}</b> engagements have <b>{1}</b> complete based on task completion',
	engagementCompletedBasedOnTaskCompletionReporting: '<b>{0}</b> engagement has completed <b>{1}</b> of tasks',
	engagementsCompletedBasedOnTaskCompletionReporting: '<b>{0}</b> engagements have completed <b>{1}</b> of tasks',
	engagementCompletedBasedOnTaskCompletionMilestone: '<b>{0}</b> engagement has completed <b>{1}</b> of tasks for this milestone',
	engagementsCompletedBasedOnTaskCompletionMilestone: '<b>{0}</b> engagements have completed <b>{1}</b> of tasks for this milestone',
	reportReleaseDate: 'Report release date',
	partnerInvited: 'Partner invited',
	picSignoffOnCra: 'PIC sign-off on CRA',
	eqrSignoffOnCra: 'EQR sign-off on CRA',
	picSignoffOnAuditPlan: 'PIC sign-off on Audit plan',
	overdueLabel: 'Overdue',

	//Team members
	teamMembersTitle: 'Team members',
	membersTitle: 'Members',
	eyContactsTitle: 'EY contacts',
	allMembersLabel: 'All members',
	internalMembersLabel: 'Internal members',
	externalMembersLabel: 'External members',
	groupsTitle: 'My groups',
	projectOwnersTitle: 'Project owners',
	projectOwnersLabel: 'Project Owners',
	projectOwnerLabel: 'Project Owner',

	//CCP
	summary: 'Summary',
	requestsByStatus: 'Requests by status',
	totalRequests: 'total requests',
	totalRequestsTitle: 'Total requests',
	receivedByEy: 'Received by EY',
	acceptedByEy: 'Accepted by EY',
	outstandingByEy: 'Outstanding',
	returned: 'Returned',
	receivedByEyOnTime: 'Received by EY on time',
	averageDaysOverdue: 'Average days overdue',
	outOfReceivedAndAccepted: '<b>{0}</b> out of <b>{1}</b> received and accepted requests',
	outOfStandingRequests: '<b>{0}</b> out of <b>{1}</b> outstanding requests',
	outOfAverageDaysOverdue: '<b>{0}</b> out of <b>{1}</b> outstanding requests',
	draftRequests: '{0} draft requests',
	noResultMessageHeader: 'There is no data to display. Select additional entities to continue.',
	noResultMessageSubHeader: '',
	members: 'members',
	memberLabel: 'member',
	adminLabel: 'Admin',
	projectOwnerLabel: 'Project owner',
	viewsLabel: 'views',
	metrics: 'Metrics',
	yes: 'Yes',
	no: 'No',
	emptyMessageAvailableGroup: 'No groups have been created yet. <br> Select <b>Add a group</b> to get started.',
	thereIsNoDataToDisplayForThisEntity: 'There is no data to display for this entity.',
	typeLabel: 'Type',
	groupsLabel: 'Groups',
	group: 'Group',
	entitiesLabels: 'Entities',
	entityLabel: 'Entity',
	nameLabel: 'Name',
	searchTeamMembers: 'Search team members',
	notSelectedLabel: 'Not selected',
	entitiesLabel: 'Entities',
	noDataAvailableLabel: 'No data available.',
	delete: 'Delete',
	deleted: 'Deleted',
	addAMember: 'Add a member',
	addMemberHeaderText: 'Add a new member to one or more groups for your project.',
	teamMemberInformation: 'Team member information',
	teamMemberNote: 'Enter the name or email for the internal or external team member who you wish to add to the selected groups. Press the Enter key to see results.',
	selectGroupNote: 'Select at least one group. Group members can view EY Canvas engagement data for all of the organizational chart entities that their groups are connected to, as well as any children of those entities.',
	inviteAndClose: 'Invite & close',
	inviteAndAddAnother: 'Invite & add another',
	contacts: 'Contacts',
	email: 'Email',
	emailAll: 'Email all',
	contactTeam: 'Contact team',
	emptyMessage: 'There are no contacts available for this engagement.',
	comingDue: 'Coming due',
	tomorrow: 'Tomorrow',
	next3days: 'Next 3 days',
	next5days: 'Next 5 days',
	next10days: 'Next 10 days',
	next30days: 'Next 30 days',
	comingDueNext5days: 'Coming due (next 5 days)',
	entityDetails: 'Entity details',
	requestsByEntity: 'Requests by entity',
	basedOnTheSelectedCategory: 'Based on the selected category',
	requestCount: 'Request count',
	selectedDay: 'Selected day',
	editMember: 'Edit member',
	editMemberHeaderText: 'Edit the groups that the selected team member has access to.',
	editaGroup: 'Edit group',
	editAGroupHere: 'Edit a group here',
	selectAnotherFrame: 'Select another time frame to view data.',
	emptyFrameShort: 'Select additional entities to continue.',
	emptyFrame: 'Select additional entities or a different time frame to continue.',
	editMemberHeaderText: 'Edit the groups that the selected team member has access to.',
	confirm: 'Confirm',
	markCompleteModalInstrTextPart1: 'Are you sure that you want to complete this project?',
	markCompleteModalInstrTextPart2: 'Once you take this action, it cannot be undone.  Completed projects can be rolled forward and used as a template when creating a new project.',
	firstPage: 'First page',
	lastPage: 'Last page',
	nextPage: 'Next page',
	prevPage: 'Previous page',

	// Add Tag
	keyContacts: 'Key contacts',
	customTags: 'Custom Tags',

	// Manage Tags
	manageTagInstructional: 'Create new custom tags here. You can also edit and delete existing custom tags. Tagging contacts gives you the flexibility to manage contacts in your EY Canvas Oversight project.',
	emptyCustomTagsList: 'No custom tags have been created yet.',
	manageTagTitle: 'Manage custom tags',
	manageTagLinkButton: 'Manage tags',
	color: 'Color',
	tagName: 'Name',
	tagDelete: 'Delete',
	tagCreate: 'Create new tag',
	customTagsHeader: 'Custom tags',

	//preparer assignment tile
	totalPreparerAssignments: 'total preparer assignments',
	inprogress: 'In progress',
	preparerAssignments: 'Preparer assignments',
	byAssignmentStatus: 'By assignment status',
	taskWithoutPreparerAssignments: 'task without preparer assignments',
	tasksWithoutPreparerAssignments: 'tasks without preparer assignments',
	preparerFilterTitle: 'Preparer',

	// reviewer assignment tile
	totalReviewerAssignments: 'total reviewer assignments',
	taskWithoutReviewerAssignments: 'task without reviewer assignments',
	tasksWithoutReviewerAssignments: 'tasks without reviewer assignments',
	reviewerFilterTitle: 'Reviewer',

	assignments: 'Assignments',
	notes: 'Notes',
	preparerNotAssigned: 'Preparer not assigned',
	reviewerAssignments: 'Reviewer assignments',
	reviewerNotAssigned: 'Reviewer not assigned',
	basedOnPreparerAssignments: 'Based on preparer assignments',
	basedOnPreparerAssignmentsOpenAndInProgress: 'Based on preparer assignments with Open and In Progress status',
	basedOnReviewerAssignments: 'Based on reviewer assignments',
	basedOnReviewerAssignmentsOpenAndInProgress: 'Based on reviewer assignments with Open and In Progress status',

	statusOpen: 'Status - Open',
	statusInProgress: 'Status - In-progress',
	statusClosed: 'Status - Closed',
	byPriorityLow: 'By priority - Low',
	byPriotityMedium: 'By priority - Medium',
	byPriorityHigh: 'By priority - High',
	byPriorityCritical: 'By priority - Critical',

	findingsLabel: 'Findings',
	riskLabel: 'Risks',
	digitalAuditLabel: 'Digital audit',
	digitalAuditStrategy: 'Digital audit strategy',
	byDigitalAuditTypeLabel: 'By digital audit strategy',
	basedOnProfileSelection: 'Based on profile selection',
	basedOnSelectionArchiveForm: 'Based on selection on the archive form',
	MisstatementsByType: 'Misstatements by type',
	DeficienciesBySeverity: 'Deficiencies by severity',
	MisstatementsLabel: 'Misstatements',
	DeficienciesLabel: 'Deficiencies',
	primarTeamDeficiencyHeader: 'Primary teams - {0}',
	componentRegionalTeamDeficiencyHeader: 'Regional and component teams - {0}',
	auditTileHeaderTextPrimary: 'Primary teams - {0}',
	componentRegionalTeamHeader: 'Regional and component teams - {0}',
	allTeamDeficiencyHeader: 'All engagements - {0}',
	primarTeamMisstatementHeader: 'Primary teams - {0}',
	componentRegionalTeamMisstatementHeader: 'Regional and component teams - {0}',
	allTeamMisstatementHeader: 'All engagements - {0}',
	deficiencyLabel: 'Deficiency',
	inherenRisktLabel: 'Risk of material misstatement',
	significantRiskLabel: 'Significant',
	fraudRiskLabel: 'Fraud',
	significantDeficiencyLabel: 'Significant deficiency',
	materialWeaknessLabel: 'Material weakness',
	factualLabel: 'Factual',
	projectedLabel: 'Projected',
	judgmentalLabel: 'Judgmental',
	reclassificationLabel: 'Reclassification',
	totalDeficiencyLabel: 'total deficiency',
	totalRiskLabel: 'total risk',
	totalRisksLabel: 'total risks',
	totalDeficienciesLabel: 'total deficiencies',
	totalMisstatementLabel: 'total misstatement',
	totalMisstatementsLabel: 'total misstatements',
	allEngagementHeader: 'All engagements - {0}',
	noAuditSightGroupData: '<b>No group audit data to display.</b> <br> Select <b> All </b> from the toggle to see summarized data.',
	noAuditTileDataPlaceholder: 'There is no data to display. Select additional entities to continue.',
	openReviewNotes: 'Open review notes',
	byPriorityLevel: 'By priority',
	risks: 'Risks',
	groupRoleLabel: 'Group role',
	totalRisks: 'Total risks',
	byType: 'By type',
	inherent: 'Risk of material misstatement',
	significant: 'Significant',
	fraud: 'Fraud',
	strategy: 'Strategy',
	notApplicable: 'Not applicable',
	customizableTable: 'Customize table',
	selectUpToOptionHeader: 'Select up to {0} options',
	selectUpToThreeOptionHeader: 'Select up to three options',
	selectUpToFourOptionHeader: 'Select up to four options',
	psps: 'PSPs',
	osps: 'OSPs',
	hxpsps: 'HxPSPs',
	totalSubstantiveProcedures: 'total substantive procedures',
	totalSubstantiveProcedure: 'total substantive procedures',
	totalITControls: ' total ITGCs and ITSPs',
	totalITControl: 'total ITGC and ITSP',
	testing: 'Testing',
	nonTesting: 'Not testing',
	auditStrategy: 'Audit strategy',
	totalControls: 'total controls',
	totalControl: 'total control',
	removeProject: 'Remove project',
	removeProjectInstructionalText: 'Are you sure that you want to remove the following project from your list of active projects? <br>If you remove the project, you will no longer be able to access it.',
	substantiveProcedures: 'Substantive',
	controls: 'Controls',
	itlabel: 'IT',

	//delegates removed
	userDelTitle: 'My delegates',
	delTitleDetail: 'You have delegated your access to the team members listed here. Your delegates have access to all clients that you have access to.',
	delElseMsg: 'You have not added any delegates yet.',
	delegateTitle: 'Remove a delegate',
	delegateMember: 'Delegated',
	deleteMessage: 'Are you sure that you want to remove this delegate?<br/> Once removed, they will no longer be able to create projects on your behalf.',

	//Advanced filters.
	advancedFilters: 'Advanced filters',
	selectAll: 'Select all',
	deselectAll: 'Deselect all',
	applyFilters: 'Apply filters',
	region: 'Region',
	country: 'Country',
	city: 'City',
	state: 'State',
	advancedFiltersInstructionalText: 'Select the entities for which you would like to view engagement data.',
	advancedFiltersInstructionalTextLine2: 'Entities that you do not have access to appear disabled. Speak with a Group Administrator if you require access.',
	engagementsSelected: 'engagement(s) selected',
	filterYes: 'Yes',
	filterNo: 'No',

	//Group Audit
	pendingResponse: 'Pending response',
	primaryTileTitle: 'Primary team status',
	reportingFormStatus: 'Reporting form status',
	reportingForm: 'Reporting form',
	summarizedForPrimaryTeams: 'Summarized for primary teams',
	primaryTileSubtitle: 'group reporting forms sent',
	received: 'Received',
	dueToPrimaryTeam: 'Due to primary team',
	sentToPrimaryTeam: 'Sent to primary team',
	evidencePending: 'Evidence pending',
	evidenceComplete: 'Evidence complete',
	componentTileTitle: 'Component team status',
	componentTaskStatus: 'Component task status',
	componentTask: 'Component task',
	comingsoonTaskStatus: 'Coming soon',
	summarizedForComponentTeams: 'Summarized for component teams',
	componentTileSubtitle: 'group audit tasks received',
	unlinkedTask: 'unlinked task',
	unlinkedTasks: 'unlinked tasks',

	//Group Risk Assessment
	groupRiskAssessmentTitle: 'Risks',
	groupRiskSummaryTitle: 'Group risk assessment',

	// Reporting
	reportModifications: 'Report modifications',
	byReportType: 'By report type',
	notSelected: 'Not selected',
	unmodified: 'Unmodified',
	modified: 'Modified',
	reports: 'Reports',
	opinions: 'opinions',
	modifiedReports: 'Modified reports',
	modifiedOpinions: 'Modified opinions',
	adverse: 'Adverse',
	disclaimer: 'Disclaimer',
	qualification: 'Qualification',
	qualified: 'Qualified',
	engagementReportTooltip: 'Only engagements with report dates on or before the current date are summarized here. All engagements are displayed in the table below.',
	geography: 'Geography',
	standars: 'Standards',
	gaap: 'GAAP',
	gaapUs: 'GAAP US',
	ifrs: 'IFRS',
	other: 'Other',
	yearEndDate: 'Year-end date',
	endDateOfPeriodCovered: 'End date of period covered',
	reportDate: 'Report date',
	archiveDeadline: 'Archive deadline',
	reportType: 'Report type',
	opinionType: 'Opinion type',
	taskStatus: 'Task status',
	exportData: 'Export data',
	exportToExcel: 'Export',
	orgChartEntity: 'Org chart entity',
	engagementId: 'Engagement ID',
	contactName: 'Contact name',
	contactEmail: 'Contact email',
	statusInherent: 'By Type - Risk of material misstatement',
	statusSignificant: 'By Type - Significant',
	statusFraud: 'By Type - Fraud',
	substantivePSPs: 'Substantive - PSPs',
	substantiveOSPs: 'Substantive - OSPs',
	substantiveHxPSPs: 'Substantive - HxPSPs',
	controlsTesting: 'Controls - testing',
	controlsNonTesting: 'Controls - Non testing',
	iTTesting: 'IT - testing',
	iTNonTesting: 'IT - Non testing',
	misstatementsFactual: 'Misstatements - Factual',
	misstatementsProjected: 'Misstatements - Projected',
	misstatementsJudgmental: 'Misstatements - Judgmental',
	misstatementsReclassification: 'Misstatements - Reclassification',
	deficienciesDeficiency: 'Deficiencies - Deficiency',
	deficienciesSignificantdeficiency: 'Deficiencies - Significant deficiency',
	deficienciesMaterialweakness: 'Deficiencies - Material weakness',
	statusComplete: 'Status - Complete',
	statusInReview: 'Status - In review',
	statusInProgress: 'Status - In progress',
	statusOpen: 'Status - Open',
	statusNotSent: 'Status - Not sent',
	statusReturned: 'Status - Returned',
	statusDocumentationPending: 'Status - Documentation pending',
	statusDocumentationComplete: 'Status - Documentation complete',
	statusReceivedbyEY: 'Status - Received by EY',
	statusAcceptedbyEY: 'Status - Accepted by EY',
	statusOutstanding: 'Status - Outstanding',
	noCompletedProjectsMessagePart1: 'You do not have any completed projects.',
	noCompletedProjectsMessagePart2: 'If you are a project owner, then you can mark a project as completed. Completed projects can be rolled forward and used as a template when creating a new project.',
	noCompletedProjectsMessage: 'You do not have any completed projects. <br>If you are a project owner, you may mark the project completed. Completed projects can be rolled forward and used as a template when creating a new project.',
	requests: 'Requests',

	//Reporting readiness report
	week: 'week',
	weeks: 'weeks',
	readinessReportTitle: 'Report readiness',
	taskCompletionByEngagement: 'Task completion by engagement',
	readinessLegendTitle: 'Proximity to report date',
	basedOnReportDateProximityForEachEngagement: 'Based on report date proximity for each engagement',

	//ReportCompletion
	taskCompletionStatus: 'Task completion status',
	taskCompletionByLocation: 'Task completion by location',
	basedOnCompletedTasksForEachEngagement: 'Based on completed tasks for each engagement',
	byGeography: 'By geography',
	taskCompletion: 'Task completion',
	completedTasks: 'completed tasks',

	engagementArchived: 'This engagement has been archived. Data is no longer available.',
	externalUsersNoActiveProjMessage: 'You do not have any active projects. Speak with an EY team member to gain access.',

	//Error Messages
	networkErrorMessage: 'The application network is experiencing an error. Refresh the page and try again later. Contact the Help Desk if the error persists.',
	genericErrorMessage: 'The selected operation could not be completed at this time. Refresh the page and try again. Contact the Help Desk if the error persists.',
	otherProjectPlaceholder: 'Your EY Canvas engagements are connected to the EY Canvas Oversight projects listed here.  You do not have access to these projects.  Speak with a project owner or group administrator to gain access.',
	noProjectsAvailable: 'No projects available.',
	completedProjectPlaceholder: 'Your completed EY Canvas Oversight projects are listed here.  Select the <b> Roll forward </b> option to use your completed project as a template when creating a new project.',
	completedNotProjectPlaceholder: 'You do not have any completed projects. <br>If you are a project owner, you may mark the project completed. Completed projects can be rolled forward and used as a template when creating a new project.',

	//Log out and time out modal
	logoutModalTitle: 'Automatic logout for your protection',
	sessionTimerMsgLine1: 'Due to inactivity, your current work session is about to expire.',
	sessionTimerMsgLine2: 'For your security, EY Canvas Oversight sessions end automatically after 30 minutes of inactivity.',
	sessionTimerMsgLine3: 'Your current session will expire in {0} minutes.',
	sessionTimerMsgLine4: 'If you wish to remain logged in, please click',
	modalContinueButton: '<b>Continue</b>',
	modalLogoutButton: 'Log out',
	modalCloseButton: 'Close',
	countryNotAvailable: 'Country not available',
	regionNotAvailable: 'Region not available',
	notAvailable: 'Not available',
	signout: 'Sign out',
	engagementTypeNotAvailable: 'Engagement type not available',

	// Admin portal
	administration: 'Administration',
	mainPageInstructionalText: 'Welcome to the EY Canvas Oversight Administrative Portal',
	manageProjectsFormatted: 'Manage <br />projects',
	manageUsersFomatted: 'Manage <br />users',
	manageAdminsFormatted: 'Manage <br />Oversight admins',
	homeLabel: 'Home',
	userNotFoundError: 'User not found.',
	manageUsersInstructionalText: 'Search for a user by entering their GUI',
	selectRole: 'Select role',
	role: 'Role',

	//Manage User
	manageUsersTitle: 'Manage users',
	otherProjectsTabTitle: 'Other projects',
	validGuiErrorMsg: 'Enter a valid GUI',
	accessibleProjects: 'Accessible projects',
	delegates: 'Delegates',
	projectID: 'Project ID',
	projectStatus: 'Project status',
	gui: 'GUI',
	emailAddress: 'Email address',
	userRole: 'User role',
	userID: 'User ID',
	noResultMessage: 'No results match the search criteria.',
	noResultFound: 'No records found.',
	userDetails: 'User details',
	active: 'Active',
	inActive: 'Inactive',
	manageAdmins: 'Manage EY Canvas Oversight administrators',
	manageAdminsInstructionalText: 'All EY Canvas Oversight administrators are listed below.  You can edit the roles for an administrator, add, and remove administrators.',
	adminReader: 'Application admin reader',
	adminWriter: 'Application admin writer',
	superAdmin: 'Application super admin',
	revertChanges: 'Revert changes',
	unSavedChanges: 'Unsaved changes',
	unSavedChangesMessage: 'You have unsaved changes that will be lost if you continue. <br/> Select <b>Confirm</b> to continue. Select <b>Cancel</b> to return to the underlying page and save your changes.',
	addNewAdmin: 'Add new administrator',
	addEYContactInstructions: 'Enter a name or email address and press Enter to see results.  Select a role to add a new Oversight administrator.',

	// ManageProjects
	orgChartEntities: 'Org chart entities',
	manageProjectsInstructionalText: 'Search for a project by entering the project ID.',
	projectDetails: 'Project details',
	parentEntity: 'Parent entity',
	connectedGroups: 'Connected groups',
	validProjectIDError: 'Enter a valid project ID',
	addNewMember: 'Add member',
	adminAddMemberInstructionalText: 'Search for a user and select the groups to which they should be added.',
	currentApplication: 'Current application',

	//Software Update
	softwareUpdate: 'Software updates',
	updateNow: 'Update now',
	updateMsg: 'Software updates are available for EY Canvas Oversight. Select Update now to download and install the updates. The page will be refreshed.',

	//ContactDB
	placeholderForSearch: 'Search',
	contactClearAll: 'Clear all',
	contactShowMoreFilters: 'more',
	contactListFilter: 'Access to Contact list',
	dashboardAccessFilter: 'Access to Dashboard',
	groupRoleFilter: 'Group role',
	tagFilter: 'Tags',
	countryFilter: 'Country',
	serviceLineFilter: 'Service line',
	typeFilter: 'Type',
	roleFilter: 'Role',
	dashboardAccess: 'Dashboard Access',
	contactList: 'Contact list',
	noEntitiesMessage1: 'There is no data to display.',
	noEntitiesMessage2: 'Select additional entities to continue.',
	noContacts: 'There are no contacts for this entity.',
	engagementsContacts: 'Engagements',
	manuallyAdded: 'Manually added',
	dashboardViews: 'views',
	columnName: 'Name',
	columnEmail: 'Email',
	columnEngagement: 'Engagements',
	columnType: 'Type',
	columnRole: 'Role',
	columnServiceLine: 'Service line',
	columnDashboard: 'Access to Dashboard',
	columnDashboardView: 'Dashboard views',
	columnContactList: 'Access to Contact list',
	columnTags: 'Tags',
	columnEntity: 'Entity',
	noResults: 'No Result Found',
	noResultsAvailable: 'There is no data available.',
	searchContacts: 'Search contacts',
	selectedContacts: 'Selected contacts',
	tag: 'Tag',
	manageAccess: 'Manage access',
	formLengthMessage: 'Text cannot exceed {number} characters.',
	viewMoreColumns: 'View more columns',
	projectOwnerBadge: 'Project Owner',
	entityAdminBadge: 'Entity Admin',
	eyTeam: 'EY team',
	clientTeam: 'Client team',
	userProfile: 'User profile',
	columnGroupRiskAssessment: 'Access to Group risk assessment',
	externalUserDenyMessage: 'External users cannot be granted access to the Group risk assessment module.',
	//ContactDB - Toolbar
	toolbarAddContact: 'Add contact',
	toolbarAccessLog: 'Access log',
	toolbarMessageLog: 'Message log',
	toolbarCustomizeTable: 'Customize table',
	toolbarExportData: 'Export data',
	toolbarManageAccess: 'Manage access',
	toolbarDefineAttributes: 'Define attributes',
	toolbarGenerateMessage: 'Generate message',
	toolbarTags: 'Tags',
	toolbarRemove: 'Remove',

	//ContactDB - Add Contact Modal
	addContactLabel: 'Add contact',
	addContactTitle: 'Add contacts',
	addContactInstructional: 'Add one or more contacts to your EY Canvas Oversight project.  If the contacts that you are adding require access to the Dashboard or Contact list, you can grant them access here.',
	columnEntities: 'Entities',
	noEntities: 'None',
	duplicatedUser: 'has already been added as a contact. You can manage their access from the Contact list.',
	accessToDashboard: 'Access to Dashboard',
	dashBoardsViews: 'Dashboard Access and Views',
	placeholderEntities: 'Entities',
	placeholderAccess: 'Access',
	placeholderAttributes: 'Attributes',
	placeholderTags: 'Tags',
	projectOwnerAccessLabel: 'Project Owner access',
	entityAdminAccessLabel: 'Entity Admin access',
	accessToContactListLabel: 'Access to Contact list',
	saveContactLabel: 'Save',
	cancelContactLabel: 'Cancel',
	noContactsAdded: 'No contacts have been added yet.',
	noCustomColumns: 'No custom columns have been created for your project.',
	toggleContactYes: 'Yes',
	toggleContactNo: 'No',
	mustSelectOneEntity: 'You must select at least one entity to continue.',
	mustSelectOneView: 'Select at least one view for all contacts to whom you are granting access to the EY Canvas Oversight Dashboard.',
	mustBeOnwerOrAdministrator: 'You must be a project owner or entity administrator to take this action. Update the selected entities to continue.',
	cannotEditAccessForProjectOwners: 'You cannot edit access for project owners: {list}',
	attributesLabel: 'Attributes',
	externalUserDomainMismatch: 'Domain is not allowed for one or more selected entity. Add required domains in the entity setup flow and try again.',
	projectOwnerAccessToogleInfo: 'A Project owner has full permissions for an EY Oversight project.',
	entityAdminAccessToogleInfo: 'An Entity admin has Entity specific permissions to perform administrative tasks, as needed.',

	//ContactDB-CustomizeTable Modal
	customizeTableModal: 'Customize table',
	InstructionalTextCustomizeTableModal: 'Select the columns you would like to view.',
	cancelCustomizeTable: 'Cancel',
	saveCustomizeTable: 'Save',
	tooltipCustomizeTable: 'Customize table',
	standardColumns: 'Standard columns',
	customColumns: 'Custom columns',
	closeTitleModal: 'Close',
	addCustomColumn: 'Add custom column',
	editCustomColum: 'Edit custom column',
	addCustomColumnLegend: 'Custom columns allow you to capture and manage additional attributes about your contacts. You can create up to five custom columns for your project. After you create a column, you can select one or more contacts and define an attribute. If you remove a custom column, attributes for contacts will also be removed.',
	deleteCustomColumnLegend: 'Select the <b>Delete</b> icon to delete a custom column. If you proceed, then it will no longer be available for your project. Any attributes that you previously applied to contacts will also be deleted.',
	customColumnName: 'Column name',
	attribute: 'Attribute',
	attributes1to5: 'Attributes (1-5)',
	visibleToExternal: 'Visible to external contacts',
	noCustomColumnMsg: 'No custom column added',

	//ContactDB - Add Contact Modal
	filterTooltip: 'Filter',
	searchTitletip: 'Search',
	addExternalContactColumnName: 'Name',
	addExternalContactColumnDomain: 'Domain',
	confirmDomain: 'Confirm domain',

	//ContactDB - Profile Modal
	profileModalTitle: 'Profile',
	profileModalAccessSection: 'Access',
	profileModalCustomAttributesSection: 'Custom attributes',
	profileModalDashboardSection: 'Dashboard views',

	//ContactDB - Generate Message
	selectMessageRecipients: 'Select message recipients',
	notification: 'Notification',
	generateMessage: 'Generate message',
	gmInstructionalText: "Send an email or notification to the contacts you've selected. Notifications can only be sent to internal contacts. Emails can be sent to internal and external contacts.",
	messageType: 'Message type',
	messageRecipient: 'Message recipients',
	selectContactsNow: 'Select contacts now',
	useSelectedContacts: 'Use selected contacts',
	moreFilters: '+ More filters',
	countries: 'Countries',
	groupRoles: 'Group roles',
	groupRole: 'Group role',
	roles: 'Roles',
	role: 'Role',
	serviceLines: 'Service lines',
	serviceLine: 'Service line',
	contatcs: 'Contacts',
	singularContact: 'Contact',
	singularEngagement: 'Engagement',
	allContact: 'All contacts',
	allEntitles: 'All entities',
	allCountries: 'All countries',
	allGroupRoles: 'All group roles',
	allEngagements: 'All engagements',
	allServicesLines: 'All service lines',
	allRoles: 'All roles',
	subject: 'Subject',
	removeTooltip: 'Remove',
	fromEntity: 'From entity',
	fromEngagement: 'From engagement',
	notificationMessage: 'Notification message',
	linkLabel: 'Link label (Optional)',
	link: 'Link (Optional)',
	fromEntityNotification: 'From entity',
	mustSelectOne: 'You must select at least one contact to continue.',
	emailSentMsg: 'An email message was generated to the selected contacts.',
	notificationSentMsg: 'A notification has been sent to the selected contacts.',
	messageFrom: 'Message from',
	duplicateMessage: 'Duplicate message',
	someEntities: '{0} entities selected',

	//ContactDB - Message Log
	messageLogInstruction: 'Review the list of messages sent by your entity. If you need to send a follow up message, you have the option to duplicate previous messages.',
	messageLogTitle: 'Message log',
	today: 'Today',
	yesterday: 'Yesterday',
	thisWeek: 'This week',
	lastWeek: 'Last week',
	twoWeeksAgo: 'Two weeks ago',
	older: 'Older',
	notificationTo: 'Notification to',
	emailTo: 'Email to',
	sentBy: 'Sent by',
	from: 'From',
	date: 'Date',
	time: 'Time',
	subject: 'Subject',
	multiContatcsLowerCase: 'contacts',
	singleContactLowerCase: 'contact',
	seeMore: 'See more',
	seeLess: 'See less',
	messageLogEmptyMessage: 'No messages have been sent yet.',
	messageLogFileExported: 'Message log',
	typeColumnToExportToExcel: 'Type',
	sentByColumnToExportToExcel: 'Sent by',
	fromColumnToExportToExcel: 'From',
	dateColumnToExportToExcel: 'Date',
	timeColumnToExportToExcel: 'Time',
	subjectColumnToExportToExcel: 'Subject',
	contactsColumnToExportToExcel: 'Contacts',
	emailExportToExcel: 'Email',
	notificationExportToExcel: 'Notification',

	//ContactDB - Access Log
	accessLog: 'Access log',
	accessLogInstructional: 'Review the team members presented below and decide whether to add or remove them as contacts.',
	addAll: 'Add all',
	removeAll: 'Remove all',
	ignoreAll: 'Ignore all',
	contactsToAddEmpty: 'There are no potential contacts to add at this time.',
	contactsToRemoveEmpty: 'There are no potential contacts to remove at this time.',
	ignore: 'Ignore',
	addAllConfirmationModal: 'One or more users have a domain that is not permitted by an entity.  Click Continue to add the users to the Contact list.  The domain(s) will be imported and added to the list of permitted domains for the entity.',
	addConfirmationModal: 'User has a domain that is not permitted by this entity.  Click Continue to add the user to the Contact list.  The domain will be imported and added to the list of permitted domains for the entity.',

	// ContactDB - Message Log - Filter
	messageTypeFilter: 'Message type',
	sentByFilter: 'Sent by',
	fromEntityFilter: 'From entity',
	toEntityFilter: 'To entity',
	toCountryFilter: 'To country',
	toGroupRoleFilter: 'To group role',
	toEngagementFilter: 'To engagement',
	toServiceLineFilter: 'To service line',
	toRoleFilter: 'To role',

	//ContactDB - Define Attributes
	defineAttributes: 'Define attributes',

	// ContactDB Edit Entity Modal
	// Step 2 - Edit Entity Modal
	addAnotherEntityAdministrator: 'Add another entity administrator',
	editEntity: 'Edit entity',
	entityAdministrators: 'Entity administrators (optional)',
	editEntityAdministratorsInstruction: 'You have the option to add one or more entity administrators.  They can add contacts to this entity and provision access to EY Canvas Oversight modules.',
	editEntityDomainInstruction: 'External team members must have a valid domain for this entity to access EY Canvas Oversight. The system will import approved domains from connected EY Canvas engagements in Step 4 of the setup wizard. If you plan to invite other external team members to this entity, then add one or more domains. A domain is the characters after the @ symbol in an email address.',
	level: 'Level {0}',

	// ContactDB Remove Contacts
	removeIcon: 'Remove',
	removeContactTitle: 'Remove contacts',
	removeInstructionalText: 'Are you sure that you want to remove these contacts from your project? If these contacts belong to multiple entities, then they will be removed from all entities.  If you need to remove a contact from an individual entity, select to edit their access instead.',
	removeSelectedContacts: 'Selected Contacts',

	domainNotPermitted: 'The domain for one or more entity administrators is not permitted for this entity.',
	listView: 'List view',
	cardView: 'Card view',

	recordsNotAvailable: 'Records not available',

	// Project Layout Update
	welcomeLabel: 'Welcome',
	activeProjectsInstructionalText: 'You have access to the EY Canvas Oversight projects listed here.  Select a module to navigate to it or click on a count to see details for each of your projects.',
	otherProjectsInstructionalText: 'Your EY Canvas engagements are connected to the EY Canvas Oversight projects listed here.  You do not have access to these projects.  Speak with a project owner or entity administrator to gain access.',
	completedProjectsInstructionalText: 'Your completed EY Canvas Oversight projects are listed here.  Select the <b>Roll Forward</b> option to use your completed project as a template when creating a new project.',
	goToLabel: 'Go To',
	entityAdmins: 'Entity Admins',
	entityAdmin: 'Entity Admin',
	keyContacts: 'Key Contacts',
	keyContact: 'Key Contact',
	contactListLabel: 'Contact List',
	draftlabel: 'Draft',
	projectWizard: 'Project wizard',
	noEntityAdminsAdded: 'No Entity admins associated',
	addProjectOwner: 'Add Project owner',
	addProjectOwnerInstrText: 'Search for a user using their name or email to add them as a Project owner of the selected project.',
	projectSummary: 'Project Summary',
	privacyNotice: 'Privacy notice',
	groupOversightProject: 'Group Oversight project (New!)',
	groupOversightProjectTooltip: 'In <b>Group Oversight projects</b>, you can identify your Primary and/or Regional EY Canvas engagement(s) for which you are creating an EY Oversight project. The Regional and/or Component EY Canvas engagement(s) identified in your EY Canvas Group structure will <b>automatically</b> be populated as part of the EY Oversight project setup. <br><br> Additionally, these types of projects will have access to a Group risk assessment module where risk assessment activities can be viewed for the Primary, Regional and/or Component engagement(s).',
	oversightProject: 'Oversight project (Stat audits)',
	oversightProjectTooltip: 'In Oversight projects (Stat audits), you can manually select your client(s), and then your associated EY Canvas engagement(s), for which you are creating an EY Oversight project.',

	// Group Risk Assessment
	noGroupRiskAssessmentForSelection: 'There is no Group risk assessment activity for this EY Oversight project.',
	engagementData: 'Engagement data',
	engagementDetails: 'Engagement details',
	reconciliations: 'Reconciliations',
	nextComponent: 'Next component',
	prevComponent: 'Previous component',
	allAccounts: 'All accounts',
	generateEmail: 'Generate email',
	reconciliationDetailInstructional: 'The information below summarizes the total number of Primary Team accounts, and risks of material misstatement, which were related to the component in the Primary Team\'s EY Canvas engagement and included in the group risk assessment communications. Select a Primary Team account/risk to relate it to the equivalent account/risk in the component team\'s EY Canvas engagement.',
	primaryTeamAccountName: 'Primary Team account name',
	componentTeamAccountName: 'Component team account name',
	designation: 'Designation',
	openAccounts: 'Open accounts',
	componentTeamAccounts: 'Component team accounts',
	componentTeamAccountsAndPsp: 'Component team accounts and related PSP Index(es)',
	mapAccountsMessage: 'Each Primary Team account should have at least one related component team account. {button} to get started.',
	primaryTeamAccountStatus: 'Primary Team account status',
	totalAccounts: 'Total accounts',
	assessedAccounts: 'Assessed accounts',
	primaryTeamRiskStatus: 'Primary Team risk status',
	openRisks: 'Open risks',
	assessedRisks: 'Assessed risks',
	totalRisks: 'Total risks',
	primaryTeamRiskDesignationAndName: 'Primary Team risk designation and name',
	primaryTeamAccountsRelatedToRisk: 'Primary team account(s) related to risk',
	componentTeamRisksAndRelatedAccounts: 'Component team risks and related account(s)',
	relateRisks: 'Relate risks',
	relateRisksMessage: 'Each Primary Team risk should have at least one related component team risk. {button} to get started.',
	pspIndexesHeader: 'PSP',
	pspIndexes: 'PSP index(es)',
	markAssessed: 'Mark assessed',
	markReOpen: 'Re-open',
	riskMarkAssessedMessage: 'View related component team risks to assess whether risk designations, accounts and relevant assertions match the Primary Team risks and accounts included in the Primary Team group risk assessment communication. When complete, {button}.',
	riskWasPreviousAssessedMessage: "Status changed from Assessed to Open due to changes in the related risk, risk designation, account or assertions. Re-assess the risk grouping. When complete, {button}.",
	riskMarkOpenMessage: 'If changes need to be made to a risk grouping that has already been marked assessed, {button} the risk grouping. This risk grouping will appear in the Open risks view.',
	markAssessedSuccessMessage: 'The account grouping has successfully been marked assessed. To review, click \'Assessed accounts\' in the account status tile.',
	reopenAssessedAccount: 'Re-open',
	reopenAssessedAccountMessage: 'If changes need to be made to an account grouping that has already been marked assessed, {button} the account grouping. This account grouping will appear in the Open accounts view.',
	reopenSuccessMessage: 'The account grouping has successfully been re-opened. To view, click \'Open accounts\' in the account status tile.',
	teamAccountMappedMessage: 'View related component team accounts to assess whether account designations, relevant assertions and inherent risk assessments match the Primary Team accounts included in the Primary Team group risk assessment communication. When complete, {button}.',
	teamAccountWasPreviousAssessedMessage: 'Status changed from Assessed to Open due to changes in the related account, account designation or inherent risk assessment. Re-assess the account grouping. When complete, {button}.',
	createComment: 'Create comment',
	editComment: 'Edit comment',
	commentTitle: 'Comment',
	createCommentInstructionalText: "Enter comment details for the selected account or risk and select 'Save' to finish.",
	editCommentInstructionalText: "Edit comment details for the selected account or risk and select  'Save' to finish.",
	lastModified: 'Last modified',
	addComment: 'Add comment',
	accountDescription: 'Select Open accounts to view Primary team accounts that have not been related to Component team accounts and marked assessed. Select Assessed accounts to view Primary team accounts that have been assessed.',
	riskDescription: 'Select Open risks to view Primary team risks that have not been related to Component team risks and marked assessed. Select Assessed risks to view Primary team risks that have been assessed.',
	successAssessedMessage: 'The risk grouping has successfully been marked assessed. To review, click \'Assessed risks\' in the risk status tile.',
	successReOpenMessage: 'The risk grouping has successfully been re-opened. To view, click \'Open risks\' in the risk status tile.',

	// Relate risks modal
	relateRisksModalTitle: 'Relate component team risks',
	relateRisksModalInstructionalText: 'Select risk(s) from the component team\'s EY Canvas engagement listed below to relate to the selected Primary Team risk.',
	primaryRegionTeamRisk: 'Primary Team risk:',
	primaryTeamRiskLabel: 'Primary team risk',
	thereIsNoDataToDisplayForThisSelection: 'There is no data to display for this selection.',
	accountAndAsssociated: 'Account(s) and associated PSP index(es)',
	noAccountOrPspAssociated: 'There is not account or associated PSP index.',
	disabledRegionComponentTeamRiskLabel: "This Component team risk is already mapped to another Primary team risk. A Component team risk can only be mapped to one Primary team risk. Select 'Relate risks' for the relevant Primary risk to unrelate this risk, as applicable.",
	selectOneOrMore: 'Select one or more',

	relateAccountsModalTitle: 'Relate component team accounts',
	relateAccountName: 'Primary Team account:',
	relateAccountpspIndexes: 'PSP index(es):',
	relateAccountInstructionalText: 'Select account(s) from the component team\'s EY Canvas engagement listed below to relate to the selected Primary Team account.',
	pspIndexcountLabel: 'PSP indexes related to the Primary/Region team account',
	relateAccounts: 'Relate accounts',

	viewComponentTeamAccountsText: 'View component team accounts not related and/or not applicable',
	componentTeamAccountsModalTitle:'Component team accounts not related and/or not applicable',
	componentTeamAccountsModalInstructionalText: "The list below displays the account(s) in the component team's EY Canvas engagement that are not related to a Primary Team account. Return to the component team reconciliation details screen to relate an account to a Primary Team account. Alternatively, if a component team account is not applicable to the group audit, mark as 'Not applicable'. <br/><br/> Marking an account 'Not applicable' will move the account to the 'Not applicable' tab. Accounts should be marked 'Not applicable' if they are not applicable to the group audit.",
	componentTeamAccountsModalNotApplicableInstructionalText: '\'Not applicable\' component team account(s) are marked this way because they are not applicable to the group audit. <br/><br/> If an account is listed below in error, select \'Undo not applicable\' to move the account to the \'Not related\' tab. Account(s) that are \'Not related\' should either be related to a Primary Team account in the Relate component team accounts modal or marked \'Not applicable\' if not applicable to the group audit.',
	notRelatedTab: 'Not related',
	notApplicableTab: 'Not applicable',
	unmapped: 'Unmapped',
	unrelate: 'Unrelate',
	undoNotApplicable: 'Undo not applicable',
	action: 'Action',
	notApplicableActionTitletip: "Selecting 'Unrelate' will move the risk to the 'Not related' tab. Risks that are 'Not related' should either be related to a Primary team risk or be marked 'Not applicable' if they are not applicable to the group audit.",
	notRelatedActionTitletip: "Selecting 'Not applicable' will move the risk to the 'Not applicable' tab. Component team risks that are 'Not applicable' are not applicable to the group audit.",

	higherInheritRisk: 'Higher inherent risk',
	lowerInheritRisk: 'Lower inherent risk',
	incompleteInheritRisk: 'Incomplete inherent risk',
	riskAssociated: 'Risk associated',
	riskAssociatedHigher: 'Risk associated and contributes to the higher inherent risk',
	
	viewComponentTeamRisks: 'View component team risks not related and/or not applicable',
	unmappedRisksModalTitle: 'Component team risks not related and/or not applicable',
	unmappedRisksModalInstructional: 'The list below displays the risk(s) in the component team\'s EY Canvas engagement that are not related to a Primary Team risk. Return to the component team reconciliation details screen to relate a risk to a Primary Team risk. Alternatively, if a component team risk is not applicable to the group audit, mark as \'Not applicable\'. <br/><br/> Marking a risk \'Not applicable\' will move the risk to the \'Not applicable\' tab. Risks should be marked \'Not applicable\' if they are not applicable to the group audit.',
	notApplicableRisksModalInstructional: "'Not applicable' component team risk(s) are marked this way because they are not applicable to the group audit. <br/><br/> If a risk is listed below in error, select 'Undo not applicable' to move the risk to the 'Not related' tab. Risk(s) that are 'Not related' should either be related to a Primary Team risk in the Relate component team risks modal or marked 'Not applicable' if not applicable to the group audit.",
	added: 'Added',

	groupRiskAssessmentInstructional: "The Group risk assessment Reconciliation allows the Primary Team to view the accounts and risks of material misstatement created in the component team's EY Canvas engagement.<br><br>Click on a component name below to open the component reconciliation screen where the Primary Team can relate the accounts and risks of material misstatement that were related to the component in the Primary Team's EY Canvas engagement to the accounts and risks of material misstatement that exist in the component team's EY Canvas engagement.<br><br>The Reconciliation can assist the Primary Team to identify any deviations from the group risk assessment information communicated in the group instructions, such as differences in accounts, account designations, relevant assertions, inherent risk assessments, and identified risks of material misstatement and help facilitate group involvement discussions with component teams.",
	groupRiskAssessmentActivityFeedInstructional: "The Activity feed allows the Primary Team to view any changes to the risk assessment made by the component teams in their local EY Canvas engagement. Activities highlighted include changes made in the underlying component EY Canvas engagement to accounts, account designations, assertions and identified risks of material misstatements since the creation of the EY Canvas Oversight project. This is not reflecting activity in the Reconciliation.",
	disclaimerInstructional: 'The EY Canvas Oversight Group risk assessment functionality can support effective project management by a Primary Team in a group audit. However, this functionality is not intended to provide, document or generate audit evidence. Further, it is not intended to replace the Primary Team\'s involvement in the component team\'s work, including review of component teams reporting deliverables. We do not include screenshots or data exported from EY Canvas Oversight in the Primary Team\'s EY Canvas as evidence of the Primary Team\'s involvement in, or supervision of, the work of component teams.'
};

export const temporaryLabels = {
	dryDock: 'Drydock',
	darkMode: 'Dark mode',
	dashboard: 'Dashboard',
	projects: 'Projects',
	scopeStrategy: 'Scope & Strategy',
	accountSummary: 'Account Summary',
	scotSummary: 'Scot Summary',
	craSummary: 'CRA Summary',
	itSummary: 'IT Summary',
	SPSummary: 'Substantive Evaluation Summary',
	auditPlan: 'Audit plan',
	conclusion: 'Conclusion',
	findings: 'Findings',
	changesReport: 'Changes after report date',
	teamMember: 'Team member independence',
	archiveChecklist: 'Archive checklist',
	enagagementmanagement: 'Engagement management',
	integration: 'Integration',
	guidedWorkflow: 'Guided Workflow',
	copyrightMessage: 'Copyright © <year>. All rights reserved'
};

export const createGRAProjectLabels = {
	creationInstructional: "​Enter a Project name and select one Primary or Regional EY Canvas engagement from the list below to create an EY Oversight project. <br> Based on the selected engagement, the EY Canvas engagement(s) identified in the EY Canvas Group structure will automatically be populated as part of this project's setup. Click the {link} for more information regarding EY Canvas Oversight.",
	projectName: labels.projectName,
	engagements: labels.engagementsLabel,
	searchPlaceholder: 'Search EY Canvas engagement name, ID, or client name',
	noAccessToEng: 'You do not have access to any EY Canvas engagements.',
	noDataToDisplay: labels.noDataFound,
	save: labels.save,
	cancel: labels.cancelLabel,
	engagementsRequiredMessage: 'Select at least one engagement to save.',
	userGuideLinkText: 'User Guide'
};

export const deleteCommentModalLabels ={
	titleText: 'Delete comment', 
	instructionalText: 'Are you sure you want to delete the comment?', 
	triggerText: 'Delete', 
	confirmLabel: 'Confirm', 
	cancelLabel: 'Cancel', 
	closeLabel: 'Close',
}

export const gaRoleType = [{
		id: GARoleTypeId.Primary,
		label: 'Primary'
	},
	{
		id: GARoleTypeId.Region,
		label: 'Region'
	},
	{
		id: GARoleTypeId.Component,
		label: 'Component'
	}
];

export const engagementTableLabels = {
	engagementName: 'Engagement name',
	clientName: labels.clientName,
	type: labels.typeLabel,
	gaRoleType
};

export const formLabels = {
	required: labels.required,
	maxLength: labels.formLengthMessage
};

export const activityLogTypes = {
	ProjectCreated: 'Project created date',
	GAComponentCreated: 'Component added',
	GAComponentRemoved: 'Component removed',
	GAComponentUnlinked: 'Component unlinked',
	AccountAdded: 'Account added',
	AccountRemoved: 'Account removed',
	AccountDesignationChanged: 'Account designation changed',
	AccountEstimateChanged: 'Account estimate changed',
	AccountExecutionTypeChanged: 'Account execution type changed',
	AssertionAssociated: 'Assertion associated',
	AssertionUnassociated: 'Assertion unassociated',
	AssertionInherentRiskChanged: 'Change in Inherent risk',
	AssertionControlRiskDesignationChanged: 'Change in Control risk designation',
	RiskCreated: 'Risk created',
	RiskRemoved: 'Risk removed',
	RiskAssociated: 'Risk associated',
	RiskUnassociated: 'Risk unassociated'
};

export const activityTableLabels = {
	sourceEngagement: 'Source engagement',
	activityType: 'Activity type',
	objectImpacted: 'Object impacted',
	relatedObjectImpacted: 'Related object impacted',
	relatedSecondaryObjectImpacted: 'Related secondary object impacted',
	activityDate: 'Activity date'
};

export const regionComponentRiskTableLabels = {
	regionComponentTeamRiskName: 'Component team risk name and risk designation',
	details: 'Details'
};

export const riskTypes = [{
		id: '1',
		label: 'Significant Risk'
	},
	{
		id: '2',
		label: 'Fraud Risk'
	},
	{
		id: '3',
		label: 'Inherent Risk'
	}
];

export const engagementLabels = {
	accountName: 'Account / disclosure name',
	accountTypeName: 'Designation',
	canvasEngagementId: 'Engagement Id',
	controlRiskTypeName: 'Control risk',
	engagementDescription: 'Engagement name',
	inherentRiskTypeName: 'Inherent risk',
	assertionName: 'Assertion',
	pspIndexTitle: 'PSP Index',
	riskName: 'Risk name',
	riskTypeName: 'Risk type',
	relatedTasks: 'Related tasks',
	taskStatus: 'Task status',
	controlRiskAssessment: 'Control risk assessment'
};

export const groupRiskAssessmentLabels = {
	activityFeed: labels.activityFeed,
	reconciliations: labels.reconciliations,
	lastRefreshed: labels.lastRefreshed,
	groupRiskAssessment: labels.groupRiskAssessment,
	lastRefreshedReconciliation: labels.lastRefreshedReconciliation,
	lastRefreshedActivityFeed: labels.lastRefreshedActivityFeed,
	groupRiskAssessmentInstructional: labels.groupRiskAssessmentInstructional,
	groupRiskAssessmentActivityFeedInstructional: labels.groupRiskAssessmentActivityFeedInstructional,
	disclaimerInstructional: labels.disclaimerInstructional
};

export const reconciliationsTableLabels = {
	show: labels.show,
	noDataToDisplay: 'There is no data to display for this table.',
	unselectedEntities: 'There is no reconciliation data for this EY Oversight project. Relate components to accounts in the Group instructions flow in your Primary team EY Canvas engagement for reconciliation data to be displayed here.',
	columns: {
		components: 'Components',
		open: 'Open',
		assessed: 'Assessed',
		total: 'Total'
	},
	nextComponent: labels.nextComponent,
	prevComponent: labels.prevComponent
};

export const relateAccountsTableLabels = {
	show: labels.show,
	noDataFound: labels.noDataFound,
	columns: {
		accountName: 'Component team account',
		pspIndexes: 'PSP index(es)'
	},
	nextComponent: labels.nextComponent,
	prevComponent: labels.prevComponent,
	relateAccountTableDisabledRowToolTip: "This Component team account is already mapped to another Primary team account. A Component team account can only be mapped to one Primary team account. Select 'Relate accounts' for the relevant Primary account to unrelate this account, as applicable."
};

export const notRelatedAccountsTableLabels = {
	show: labels.show,
	noDataFound: labels.noDataFound,
	columns: {
		accountName: relateAccountsTableLabels.columns.accountName,
		pspIndexes: 'PSP index(es)',
		notRelated: {
			actionColumnName: labels.action,
			titleTip: 'Marking an account \'Not applicable\' will move the account to the \'Not applicable\' tab. Accounts should be marked \'Not applicable\' if they are not applicable to the group audit.',
			actionLabel: labels.notApplicableTab
		},
		notApplicable: {
			actionColumnName: labels.action,
			titleTip: 'Selecting \'Unrelate\' will move the account to the \'Not related\' tab. Accounts that are \'Not related\' should either be related to a Primary team account or be marked \'Not applicable\' if they are not applicable to the group audit.',
			actionLabel: labels.undoNotApplicable
		}
	},
	nextComponent: labels.nextComponent,
	prevComponent: labels.prevComponent
};

export const unmappedRisksTableColumnLabels = {
	riskName: "Component team risk",
	actions: "Action"
};

export const AdminUserErrors = {
	userError: 'User not found.'
};

/*RBAC Errors*/
export const RbacErrors = {
	106: "You don't have the required permissions to perform this action."
};

export const Errors = {
	106: "You don't have the required permissions to perform this action.",
	107: "You don't have the required permissions to perform this action.",
	111: 'You cannot delegate access to yourself.',
	112: 'User not found.',
	117: 'You cannot delegate access to an external user.',
	310: 'Project not found.',
	314: 'The domain for one or more group administrators is not permitted for this group.',
	316: 'You must be a project owner or group administrator to add team members. Speak with a project owner to gain access.',
	317: 'Only internal members can be added as project owners. Following are external users: {0}. Refresh the page and try again. Contact the Help Desk if the error persists.',
	318: 'The domain for {0} is not permitted for the following group: {1}',
	319: 'This project has been completed by another project owner. Refresh the page and try again. Contact the Help Desk if the error persists.',
	321: 'You must be a project owner to complete this action. Speak with a project owner to gain access.',
	323: 'This group has been deleted by another team member. Refresh the page and try again. Contact the Help Desk if the error persists.',
	324: 'You must be a project owner for this project to complete it. Refresh the page and try again. Contact the Help Desk if the error persists.',
	325: 'You must be a project owner or group administrator to make these changes. Speak with a project owner to gain access.',
	326: 'Complete all required fields to save this project. Refresh the page and try again. Contact the Help Desk if the error persists.',
	327: 'Project already saved.',
	328: 'The team member you are attempting to add is already a member of this group.  Refresh the page and try again.',
	330: 'The last project owner cannot be deleted',
	331: 'One or more groups have been deleted by another team member. Refresh the page and try again. Contact the Help Desk if the error persists.',
	332: 'At least one project owner is required. You cannot remove yourself from this project.',
	341: 'You do not have access to selected clients or engagements.',
	343: 'You can only delete active and draft projects. Refresh the page and try again. Contact the Help Desk if the error persists.',
	344: 'You must be a project owner to delete this project. Refresh the page and try again. Contact the Help Desk if the error persists.',
	345: 'This project has been deleted by another team member. Refresh the page and try again. Contact the Help Desk if the error persists.',
	346: 'Another project owner or entity administrator has already reviewed the access for {0}. Refresh the access log and try again.',
	347: 'You must be a project owner or an entity administrator to add or remove contacts from this project. Speak with a project owner to request access.',
	348: 'You can only remove contacts from entities that you administer. The following contacts belong to entities that you are not an administrator of and cannot be removed: {0}.',
	360: 'You must be a project owner for this project to complete this action.',
	361: 'You must be a project owner or entity administrator to take this action. Speak with a project owner to request access.',
	362: 'You can only manage access for contacts that belong to the entities that you administer. The following contacts belong to entities that you are not an administrator of, and their access cannot be edited: {0}.',
	364: 'You are trying to edit access for one or more contacts that have been removed from this project.  Refresh the page and try again.',
	365: 'You are trying to edit attributes for one or more contacts that have been removed from this project: {0} Refresh the page and try again.',
	366: 'You can only edit attributes for contacts that belong to the entities that you administer. The following contacts belong to entities that you are not an administrator of: {0}',
	367: 'The custom column you are editing has been deleted by another team member. Refresh the page and try again.',
	368: 'The custom column option you are editing has been deleted by another team member. Refresh the page and try again.',
	369: 'You must be a project owner to take this action.',
	370: 'You can only edit attributes for contacts that belong to the entities that you administer. The following contacts belong to entities that you are not an administrator of: {0}',
	372: 'You must be a project owner to take this action.',
	373: 'Cannot delete a project owner from contact list page. Go to the project wizard to take the requested action.',
	374: 'You cannot remove yourself as Project Owner from this project.',
	375: 'You cannot remove the last Project Owner from a project. At least 1 Project Owner must remain.',
	376: 'You must be a Project owner to add/remove a Project owner or an Entity administrator from the project. The following contacts cannot be removed: {0}',
	378: 'Domain cannot be removed as it is in use by a contact on the Contact list page of this Oversight project. Go to the Contact list page and remove contact(s) with this domain, then return here to remove domain.',
	502: 'Get engagements call failed. Refresh the page and try again. Contact the Help Desk if the error persists.',
	503: 'You do not have access for the selected Clients.',
	601: 'Get clients call failed. Refresh the page and try again. Contact the Help Desk if the error persists.',
	1605: 'The selected user already exists.',

	1803: 'Tag operation performed with invalid project data, Please refresh the page and try again. If the issue persists, please contact Help Desk for further assistance.',
	1804: 'You must be a project owner for this project to perform this tag operation.',
	1901: 'Send message API call failed.',
	1902: 'The message can not be empty.',
	1903: 'The allowed message length is 200 characters.',
	1904: 'The allowed call back text length is 50 characters.',
	1905: 'The allowed call back uri length is 50 characters.',
	1906: 'You must select at least one filter to continue.',
	1907: 'Recipients can not be repeated.',
	1908: 'The engagement can not be empty.',
	1909: 'The message type is not a valid value.',
	1910: 'The recipient can not be an empty value.',
	1911: 'The toast message can not be empty.',
	1912: 'The recipient type is not a valid value.',
	1913: 'You do not have the appropriate access to send a notification. Speak to a project owner or entity administrator to request access.',
	1914: 'Notifications can only be sent to internal contacts. Review the message recipients and remove external contacts to continue.',
	2101: 'The EY Policy Authoring, Approvals and Notification Service​ is unavailable at this time.  We are unable to confirm if all relevant policies have been completed.  If you have not reviewed the relevant policies, refresh the page and try again.  If the issue persists, contact the Help Desk.',

	// Reconciliation
	2701: 'Get All Reconciliations call failed.',
	2702: 'Invalid request.',
	2703: 'Get by Id Reconciliations call failed.',
	2704: 'Get by Id Risks call failed.',
	2705: 'Project not found in database.',
	2706: 'Account not found in database.',
	2707: 'Engagement not found in database.',
	2708: 'Create comment call failed.',
	2709: 'Comment has already been created. Refresh the page and try again.',
	2710: 'Patch group component account call failed.',
	2711: 'Group component account not found in database.',
	2712: 'Rationale comment cannot be empty.',
	2713: 'Rationale comment cannot have more than 4000 characters.',
	2714: 'Group component risk was not found.',
	2715: 'Group component was not found.',
	2716: 'Risk was not found.',
	2717: 'Invalid group risk status value.',
	2718: 'Update Reconciliation call failed.',
	2719: 'Patch group component risk comment call failed. Refresh the page and try again.',
	2720: 'This item has been edited or deleted by another user. Please refresh and try again.',
	2721: 'Comment has already been created. Refresh the page and try again.',
	2722: 'Account is deleted.'
};

export const clientValidationErrors = {
	ErrorAtleastOneEngagementAssociationRequired: 'Connect at least one engagement to the organizational chart to continue.',
	ErrorAtleastOneGroupAssociationRequired: 'Connect at least one group to the organizational chart to continue.',
	ErrorStep2DataNotComplete: 'Enter a name for each entity on the organizational chart to continue.'
};

export const engagementsViewBy = [{
		id: 0,
		label: 'All',
		value: 'All'
	},
	{
		id: 1,
		label: 'By country',
		value: 'Country',
		groupAttributeName: 'countryName'
	},
	{
		id: 2,
		label: 'By primary office',
		value: 'Region',
		groupAttributeName: 'regionName'
	},
	{
		id: 3,
		label: 'By engagement type',
		value: 'Type',
		groupAttributeName: 'profileNature'
	}
];

export const milestones = [{
		id: 1,
		label: 'Scope',
		auditPhaseId: 1,
		value: 1
	},
	{
		id: 2,
		label: 'Strategy',
		auditPhaseId: 1,
		value: 2
	},
	{
		id: 3,
		label: 'Walkthroughs',
		auditPhaseId: 2,
		value: 3
	},
	{
		id: 4,
		label: 'Interim Control Testing',
		auditPhaseId: 2,
		value: 4
	},
	{
		id: 5,
		label: 'Interim Substantive Testing',
		auditPhaseId: 2,
		value: 5
	},
	{
		id: 6,
		label: 'Walkthroughs (year-end processes)',
		auditPhaseId: 2,
		value: 6
	},
	{
		id: 7,
		label: 'Year-end Control Testing',
		auditPhaseId: 2,
		value: 7
	},
	{
		id: 8,
		label: 'Year-end Substantive Testing',
		auditPhaseId: 2,
		value: 8
	},
	{
		id: 9,
		label: 'Conclusion',
		auditPhaseId: 3,
		value: 9
	},
	{
		id: 10,
		label: 'N/A',
		auditPhaseId: 2,
		value: 10
	},
	{
		id: 11,
		label: 'Execution',
		auditPhaseId: 2,
		value: 11
	},
	{
		id: 12,
		label: 'Scope and strategy project management',
		auditPhaseId: 1,
		value: 12
	},
	{
		id: 13,
		label: 'Other scope and strategy',
		auditPhaseId: 1,
		value: 13
	},
	{
		id: 14,
		label: 'CRA',
		auditPhaseId: 1,
		value: 14
	},
	{
		id: 15,
		label: 'Risk Assessment and Materiality',
		auditPhaseId: 1,
		value: 15
	},
	{
		id: 16,
		label: 'Finalize scope and strategy',
		auditPhaseId: 1,
		value: 16
	},
	{
		id: 17,
		label: 'Post-interim project management',
		auditPhaseId: 2,
		value: 17
	}
];

export const daysOptions = [{
		id: daySelection.tomorrow,
		value: daySelection.tomorrow,
		label: 'Tomorrow'
	},
	{
		id: daySelection.next3days,
		value: daySelection.next3days,
		label: 'Next 3 days'
	},
	{
		id: daySelection.next5days,
		value: daySelection.next5days,
		label: 'Next 5 days'
	},
	{
		id: daySelection.next10days,
		value: daySelection.next10days,
		label: 'Next 10 days'
	},
	{
		id: daySelection.next30days,
		value: daySelection.next30days,
		label: 'Next 30 days'
	}
];

export const auditPhases = [{
		id: 1,
		label: 'Scope & strategy'
	},
	{
		id: 2,
		label: 'Execution'
	},
	{
		id: 3,
		label: 'Conclusion'
	}
];

export const findings = [{
		id: 1,
		label: 'Misstatements',
		subTitle: 'Misstatements by type'
	},
	{
		id: 2,
		label: 'Deficiencies',
		subTitle: 'Deficiencies by severity'
	}
];
export const risks = [{id: 1, label: '', subTitle: 'By type'}];

export const auditStrategies = [{
		id: 1,
		label: 'Substantive',
		subTitle: 'Substantive procedures by type'
	},
	{
		id: 2,
		label: 'Controls',
		subTitle: 'Controls by testing strategy'
	},
	{
		id: 3,
		label: 'IT',
		subTitle: 'IT procedures by testing strategy'
	}
];

export const auditInsights = [{
		id: 1,
		label: 'By Group role'
	},
	{
		id: 2,
		label: 'All'
	}
];

export const projectStatus = {
	Active: 'active',
	Draft: 'draft',
	Cancel: 'cancel',
	Complete: 'completed',
	Delete: 'delete'
};

export const ProjectStatusLabels = [{
		label: 'Initial',
		id: 1,
		value: 'Initial'
	},
	{
		label: 'Draft',
		id: 2,
		value: 'Draft'
	},
	{
		label: 'Active',
		id: 3,
		value: 'Active'
	},
	{
		label: 'Cancelled',
		id: 4,
		value: 'Cancelled'
	},
	{
		label: 'Completed',
		id: 5,
		value: 'Completed'
	},
	{
		label: 'Deleted',
		id: 6,
		value: 'Delete'
	}
];

export const projectTeamEngagementTableGroup = [{
		id: 1,
		label: 'Preparer assignments'
	},
	{
		id: 2,
		label: 'Reviewer assignments'
	}
];

export const archiveReportQualifiedType = [{
		id: archiveReportQualifiedTypeId.notSelected,
		label: 'Not selected'
	},
	{
		id: archiveReportQualifiedTypeId.unqualifiedWithEmphasisOfMatter,
		label: 'Unqualified - With emphasis of matter'
	},
	{
		id: archiveReportQualifiedTypeId.unqualifiedWithoutEmphasisOfMatter,
		label: 'Unqualified - Without emphasis of matter'
	},
	{
		id: archiveReportQualifiedTypeId.qualifiedWithEmphasisOfMatter,
		label: 'Qualified - With emphasis of matter'
	},
	{
		id: archiveReportQualifiedTypeId.qualifiedWithoutEmphasisOfMatter,
		label: 'Qualified - Without emphasis of matter'
	},
	{
		id: archiveReportQualifiedTypeId.adverseOpinionWithEmphasisOfMatter,
		label: 'Adverse opinion - With emphasis of matter'
	},
	{
		id: archiveReportQualifiedTypeId.adverseOpinionWithoutEmphasisOfMatter,
		label: 'Adverse opinion - Without emphasis of matter'
	},
	{
		id: archiveReportQualifiedTypeId.disclaimerOfOpinionWithEmphasisOfMatter,
		label: 'Disclaimer of opinion - With emphasis of matter'
	},
	{
		id: archiveReportQualifiedTypeId.disclaimerOfOpinionWithoutEmphasisOfMatter,
		label: 'Disclaimer of opinion - Without emphasis of matter'
	}
];

export const strategyTableGroup = [{id: 1, label: ''}];

export const roleForMember = [{
		id: roles.partnerInCharge,
		label: 'Partner in Charge',
		roleAbbreviation: 'PTR IN CHG'
	},
	{
		id: roles.engagementPartner,
		label: 'Engagement Partner',
		roleAbbreviation: 'EP'
	},
	{
		id: roles.executiveDirector,
		label: 'Executive Director',
		roleAbbreviation: 'EXEC DIR'
	},
	{
		id: roles.principal,
		label: 'Principal',
		roleAbbreviation: 'PRINCIPAL'
	},
	{
		id: roles.seniorManager,
		label: 'Senior Manager',
		roleAbbreviation: 'SR.MANAGER'
	},
	{
		id: roles.manager,
		label: 'Manager',
		roleAbbreviation: 'MANAGER'
	},
	{
		id: roles.senior,
		label: 'Senior',
		roleAbbreviation: 'SENIOR'
	},
	{
		id: roles.staff,
		label: 'Staff',
		roleAbbreviation: 'STAFF'
	},
	{
		id: roles.intern,
		label: 'Intern',
		roleAbbreviation: 'Intrn'
	},
	{
		id: roles.engagementQualityReviewer,
		label: 'Engagement Quality Reviewer',
		roleAbbreviation: 'EQR'
	},
	{
		id: roles.otherPartner,
		label: 'Other Partner',
		roleAbbreviation: 'OTHER PTR'
	},
	{
		id: roles.gdsStaff,
		label: 'GDS - Staff',
		roleAbbreviation: 'GDS-STAFF'
	},
	{
		id: roles.advisory,
		label: 'Advisory (ITRA,TAS,Human Capital or Other)',
		roleAbbreviation: 'ADV'
	},
	{
		id: roles.tax,
		label: 'Tax',
		roleAbbreviation: 'Tax'
	},
	{
		id: roles.executiveSupportServices,
		label: 'Executive Support Services',
		roleAbbreviation: 'ESS'
	},
	{
		id: roles.generalCounsel,
		label: 'General Counsel',
		roleAbbreviation: 'GCO'
	},
	{
		id: roles.auditQualityReviewer,
		label: 'Audit Quality Reviewer',
		roleAbbreviation: 'AQR'
	},
	{
		id: roles.mlComponentTeam,
		label: 'ML Component Team',
		roleAbbreviation: 'MCT'
	},
	{
		id: roles.clientSupervisor,
		label: 'Client Supervisor',
		roleAbbreviation: 'ClntS'
	},
	{
		id: roles.clientStaff,
		label: 'Client Staff',
		roleAbbreviation: 'ClntSt'
	},
	{
		id: roles.internalAuditSupervisor,
		label: 'Internal Audit Supervisor',
		roleAbbreviation: 'IASup'
	},
	{
		id: roles.internalAuditStaff,
		label: 'Internal Audit Staff',
		roleAbbreviation: 'IASt'
	},
	{
		id: roles.regulator,
		label: 'Regulator',
		roleAbbreviation: 'Reglr'
	},
	{
		id: roles.other,
		label: 'Other (e.g. due diligence review)',
		roleAbbreviation: 'Otrs'
	},
	{
		id: roles.office,
		label: 'Office',
		roleAbbreviation: 'Off'
	},
	{
		id: roles.area,
		label: 'Area',
		roleAbbreviation: 'Area'
	},
	{
		id: roles.industry,
		label: 'Industry',
		roleAbbreviation: 'IND'
	},
	{
		id: roles.national,
		label: 'National',
		roleAbbreviation: 'NAT'
	},
	{
		id: roles.global,
		label: 'Global',
		roleAbbreviation: 'GBL'
	},
	{
		id: roles.gsdSenior,
		label: 'GDS - Senior',
		roleAbbreviation: 'GDS-SENIOR'
	},
	{
		id: roles.gsdManager,
		label: 'GDS - Manager',
		roleAbbreviation: 'GDS-MANAGER'
	}
];

export const toggleCCPEntityOptions = [{
		id: toggleCCPEntityDetail.comingDue,
		label: labels.comingDue
	},
	{
		id: toggleCCPEntityDetail.overdue,
		label: labels.taskStatusOverdue
	},
	{
		id: toggleCCPEntityDetail.returned,
		label: labels.returned
	}
];

export const reportReadinessSeries = [
	{id: readinessReportCategories.comingDueOver2Weeks, label: `> 2{break}${labels.weeks}`},
	{id: readinessReportCategories.comingDue12Weeks, label: `1-2{break}${labels.weeks}`},
	{id: readinessReportCategories.comingDueUnder1Week, label: `< 1{break}${labels.week}`},
	{id: readinessReportCategories.overDueUnder1Week, label: `< 1{break}${labels.week}`},
	{id: readinessReportCategories.overDue12Weeks, label: `1-2{break}${labels.weeks}`},
	{id: readinessReportCategories.overDueOver2Weeks, label: `> 2{break}${labels.weeks}`}
];

export const natureOfEngagementsLabels = {
	[natureOfEngagements.auditStatements.id]: 'Audit of financial statements',
	[natureOfEngagements.integratedStatements.id]: 'Integrated audit of financial statements and internal control over financial reporting',
	[natureOfEngagements.reviewStatements.id]: 'Review of interim financial statements',
	[natureOfEngagements.nonAuditAccount.id]: 'Non-audit engagement with account/assertion/SCOT functionality',
	[natureOfEngagements.nonAuditWorkPlan.id]: 'Non-audit engagement with workplan functionality only'
};

export const AdminRoles = [{
		label: 'Application admin reader',
		id: 1
	},
	{
		label: 'Application admin writer',
		id: 2
	},
	{
		label: 'Application super admin',
		id: 3
	}
];

export const userType = [{
		value: 1,
		label: 'Internal'
	},
	{
		value: 2,
		label: 'External'
	}
];

export const MessageType = [{
		value: 1,
		label: 'Email'
	},
	{
		value: 2,
		label: 'Notification'
	}
];

export const groupRole = [{
		value: 1,
		label: 'Primary team',
		id: 1,
		selected: false,
		disabled: false
	},
	{
		value: 2,
		label: 'Regional team',
		id: 2,
		selected: false,
		disabled: false
	},
	{
		value: 3,
		label: 'Component team',
		id: 3,
		selected: false,
		disabled: false
	},
	{
		value: 4,
		label: 'Component team reporting to non-EY auditors',
		id: 4,
		selected: false,
		disabled: false
	},
	{
		value: 5,
		label: 'Not applicable',
		id: 5,
		selected: false,
		disabled: false
	}
];

export const accessLogResource = [{
		id: 1,
		label: 'Contacts to add'
	},
	{
		id: 2,
		label: 'Contacts to remove'
	}
];

export const addContactsTabsResource = [{
		id: 1,
		label: 'Access'
	},
	{
		id: 2,
		label: 'Attributes'
	},
	{
		id: 3,
		label: 'Tags'
	}
];

export const tags = [{
		name: 'Audit partner',
		id: 'auditPartner'
	},
	{
		name: 'Audit engagement manager',
		id: 'auditEngagementManager'
	},
	{
		name: 'GDS engagement manager',
		id: 'gdsEngagementManager'
	},
	{
		name: 'Tax partner',
		id: 'taxPartner'
	},
	{
		name: 'Tax engagement manager',
		id: 'taxEngagementManager'
	},
	{
		name: 'FAIT partner',
		id: 'faitPartner'
	},
	{
		name: 'FAIT engagement manager',
		id: 'faitEngagementManager'
	},
	{
		name: 'Advisory partner',
		id: 'advisoryPartner'
	},
	{
		name: 'Advisory engagement manager',
		id: 'advisoryEngagementManager'
	},
	{
		name: 'Specialist',
		id: 'specialist'
	},
	{
		name: 'Client administrator',
		id: 'clientadministrator'
	}
];

export const dashboardContactViews = [{
		id: dashboardTabId.milestones,
		value: dashboardViewsConstants.milestones,
		tooltipText: 'Audit progress by milestone.',
		key: 'Milestones',
		checked: false
	},
	{
		id: dashboardTabId.projectManagement,
		value: dashboardViewsConstants.projectManagement,
		tooltipText: 'Status of review notes and assignments, including overdue items. External users cannot be granted access to the Project management dashboard.',
		key: 'Project management',
		checked: false
	},
	{
		id: dashboardTabId.groupAudit,
		value: dashboardViewsConstants.groupAudit,
		tooltipText: 'Primary and component team status, including returned and overdue items.',
		key: 'Group audit',
		checked: false
	},
	{
		id: dashboardTabId.groupRiskAssessment,
		value: dashboardViewsConstants.groupRiskAssessment,
		tooltipText: 'View of group risk assessment across the primary and component teams. This view will not be visible to clients.',
		key: 'Group risk assessment',
		checked: false
	},
	{
		id: dashboardTabId.canvasClientPortal,
		value: dashboardViewsConstants.ccp,
		tooltipText: 'Request status, including coming due, overdue and returned items.',
		key: 'EY Canvas Client Portal',
		checked: false
	},
	{
		id: dashboardTabId.insights,
		value: dashboardViewsConstants.insights,
		tooltipText: 'Comparison of risks, substantive procedures, control strategy and findings between primary and component teams. External users cannot be granted access to the Insights dashboard.',
		key: 'Insights',
		checked: false
	},
	{
		id: dashboardTabId.reporting,
		value: dashboardViewsConstants.reporting,
		tooltipText: 'Report readiness, modifications and task completion status by country.',
		key: 'Reporting',
		checked: false
	}
];

export const colorOptionsLabels = {
	red: 'Red',
	orange: 'Orange',
	teal: 'Teal',
	blue: 'Blue',
	purple: 'Purple',
	green: 'Green',
	yellow: 'Yellow',
	gray: 'Gray'
};

export const exportToExcelLabels = {
	yes: 'Yes',
	no: 'No',
	exportData: labels.exportData,
	exportButtonTitle: 'Click here to download detailed client request information for the entities selected in the organization chart in the left-hand rail of this EY Oversight project.',
	projectInfo: 'Project info',
	exportDate: 'Export date',
	engagementName: labels.engagementNameLabel,
	engagementId: labels.engagementId,
	requestItemNumber: 'Request item number',
	requestTitle: 'Request title',
	priority: 'Priority',
	status: labels.status,
	receivedDate: 'Received date',
	dueDate: 'Due date',
	overdue: labels.overdueLabel,
	eyContact: 'EY contact',
	assignedTo: 'Assigned to',
	statusLabels: [{
			id: 1,
			label: 'Draft'
		},
		{
			id: 2,
			label: 'No Client Contact'
		},
		{
			id: 3,
			label: 'Sent'
		},
		{
			id: 4,
			label: 'System Error'
		},
		{
			id: 5,
			label: 'Invalid Client Contact'
		},
		{
			id: 6,
			label: 'Pending Response'
		},
		{
			id: 7,
			label: 'Received'
		},
		{
			id: 8,
			label: 'Accepted'
		},
		{
			id: 9,
			label: 'Returned'
		},
		{
			id: 10,
			label: 'Withdrawn'
		},
		{
			id: 11,
			label: 'Send In Progress'
		},
		{
			id: 12,
			label: 'Accept In Progress'
		},
		{
			id: 13,
			label: 'Withdraw In Progress'
		},
		{
			id: 14,
			label: 'Delete In Progress'
		},
		{
			id: 15,
			label: 'Return In Progress'
		},
		{
			id: 16,
			label: 'Response In Progress'
		},
		{
			id: 17,
			label: 'Deleted'
		},
		{
			id: 18,
			label: 'Invalid Client Contact Returned'
		},
		{
			id: 19,
			label: 'Recall In Progress'
		},
		{
			id: 20,
			label: 'Recalled'
		},
		{
			id: 21,
			label: 'Completion In Progress'
		},
		{
			id: 22,
			label: 'Recall In Progress'
		}
	],
	priorityTypeLabels: [{
			id: 1,
			label: 'Low'
		},
		{
			id: 2,
			label: 'Medium'
		},
		{
			id: 3,
			label: 'High'
		},
		{
			id: 4,
			label: 'Critical'
		}
	],

	risks: {
		exportButtonTitle: 'Click here to download detailed Risk assessment data for the entities selected in the organization chart in the left-hand rail of this EY Oversight project.',
		tabTitle: 'Risk assessment details',
		columns: {
			engagementName: labels.engagementNameLabel,
			engagementId: labels.engagementId,
			accountName: 'Account / disclosure name',
			pspIndex: 'PSP Index',
			accountType: 'Designation',
			assertion: 'Assertion',
			inherentRisk: 'Inherent risk',
			controlRisk: 'Control risk',
			craValue: 'Control risk assessment',
			riskType: 'Risk type',
			riskName: 'Risk name',
			relatedTasks: 'Related tasks',
			taskStatus: 'Task status'
		}
	},
	exportButtonTooltip:'Click here to download detailed reconciliation data for the Primary team and related Component team.',
	primaryTeamEngagementName: 'Primary team engagement name',
	componentTeamEngagementName: 'Component team engagement name',
	howToUseThisExport: 'How to use this export:',
	howToUseThisExportText: 'The information in the "Accounts" and "Risks" tabs of this excel file summarizes the ​reconciliation of the accounts and risks included in the Primary Team group risk assessment communication to the accounts and risks existing in the component EY Canvas engagement.\n On the "Accounts" tab, we are displaying the list of relevant Primary and component team accounts. In addition, we are displaying the details of each Primary and component team account, including account name, associated PSP index(es), account designation and the associated assertions. If Primary and component team account(s) have been related or marked assessed in Oversight - Reconciliation data, the Primary team and component team account(s) rows below will be grouped together. Additionally, comments left in Oversight - Reconciliation data will be reflected below.\n On the "Risks" tab, we are displaying the list of relevant Primary and component team risks. In addition, we are displaying the details of each Primary and component team risk, including risk name, risk designation, accounts related to the risks and the associated PSP index(es) to the accounts. If Primary and component team risk(s) have been related or marked assessed in Oversight - Reconciliation data, the Primary team and component team risk(s) rows below will be grouped together. Additionally, comments left in Oversight - Reconciliation data will be reflected below.',
	reconciliationComponentExportTabTitle: 'Accounts',
	reconciliationComponentExport: {
		status: 'Status',
		primaryTeamAccountName: 'Primary Team account name',
		componentTeamAccountNames: 'Component team account name(s)',
		pspIndexes: 'PSP Index(es)',
		designation: 'Designation',
		c: 'C',
		eo: 'E/O',
		mv: 'M/V',
		ro: 'R&O',
		pd: 'P&D',
		comment: 'Comment'
	},
	groupRiskStatusLabels : {
		[groupRiskStatus.open]: "Open",
		[groupRiskStatus.assessed]: "Assessed",
		[groupRiskStatus.mapped]: "Mapped",
		[groupRiskStatus.unmapped]: "Unmapped",
		[groupRiskStatus.notApplicable]: "Not applicable",
		[groupRiskStatus.systemReOpened]: "Open"
	},
	reconciliationExportTabRisks: 'Risks',
	reconciliationExport: {
		status: 'Status',
		primaryTeamRiskName: 'Primary team risk name',
		componentTeamRiskName: 'Component team risk name(s)',
		riskDesignation: 'Risk designation',
		accountsRelatedToRisk: 'Account(s) related to risk',
		c: 'C',
		eo: 'E/O',
		mv: 'M/V',
		ro: 'R&O',
		pd: 'P&D',
		comment: 'Comment'
	}
};

export const accountDesignationsLabels = {
	[accountDesignations.significantAccount]: 'Significant account',
	[accountDesignations.limitedRiskAccount]: 'Limited risk account',
	[accountDesignations.insignificantAccount]: 'Insignificant',
	[accountDesignations.otherAccount]: 'Other',
	[accountDesignations.significantDisclosure]: 'Significant disclosure'
};

export const riskDesignationsLabels = {
	[riskTypeIds.significant]: 'Significant Risk',
	[riskTypeIds.fraud]: 'Fraud Risk',
	[riskTypeIds.insignificant]: 'Insignificant Risk'
};
